export const formatAddress = (address: string): string =>
    `${address.substring(0, 6)}...${address.substring(address.length - 4, address.length)}`;
